import { createSlice } from "@reduxjs/toolkit";

export const loginSlice = createSlice({
  name: "login",
  initialState: {
    value: 0,
  },
  reducers: {
    signIn: (state, action) => {
      state.value = 1;
    },
    signOut: (state) => {
      state.value = 0;
    },
  },
});

// Action creators are generated for each case reducer function
export const { signIn, signOut } = loginSlice.actions;

export const loginState = (state) => state.login.value;

export default loginSlice.reducer;
